<div class="main-wrapper">
<div class="row" [ngClass]="termsAndConditionsHeading == 'Privacy policy' ? '' : 'location'">
    <!-- <div class="col-lg-12 heading" [innerHTML]="termsAndConditionsHeading"></div> -->
    <br>
    <div class="col-lg-12 card-content"  [innerHTML]="termsAndConditionsReadMore"></div>
</div>
</div>
